import React from 'react';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,ParentAnchor } from './blockComponents';
import { PlainImage } from './imageComponents';
import H3 from './styledComponents/H3';
import H4 from './styledComponents/H4';
import IdeaGeneral from './styledComponents/IdeaGeneral';
import Paragraph from './styledComponents/Paragraph';
import ChapterSpace from './styledComponents/ChapterSpace';

function Works({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
    return (
        <ParentAnchor
            key='worksSection'
            blockId="works-section"
            blockName='worksSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_6' })} downloadLink="https://drive.google.com/drive/folders/1IoyjAwIrcxVRZ43vUh4r823u7OCu7grQ?usp=sharing"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <IdeaGeneral space="Top">
                            <Paragraph space="Down">{intl.formatMessage({ id: 'work_1_2' })}</Paragraph>
                            <Paragraph><FormattedHTMLMessage id="work_1_3" /></Paragraph>
                        </IdeaGeneral>
                        <AnchorBlock
                            key='postersBlock'
                            blockName='postersBlock'
                            blockId='posters'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'work_1_1' })}</H3>
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="works/poster-2@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="works/poster-1@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="works/poster-4@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="works/poster-3@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="works/poster-6@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="works/poster-5@2x.jpg" alt="" />
                                </Cell>
                            </Grid>
                            <PlainImage src="works/poster-7@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                        <AnchorBlock
                            key='printedMaterials'
                            blockName='printedMaterials'
                            blockId='printed-materials'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'work_2_1' })}</H3>
                            <H4 space="Down">{intl.formatMessage({ id: 'work_2_2' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'work_2_3' })}</Paragraph>
                            <PlainImage src="works/liflet-pro@2x.jpg" last="xs" alt="" />
                            <H4 space="TopDown">{intl.formatMessage({ id: 'work_2_4' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'work_2_5' })}</Paragraph>
                            <PlainImage src="works/liflet-mini@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor> 
    )
}

export default injectIntl(Works)